import { Injectable } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';

/*
  Generated class for the ReportsProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ReportsProvider {
  collection: any;

  constructor(
    private afs: AngularFirestore
  )
  {
    // console.log('Hello ReportsProvider Provider');
  }


  async getReports(){
    // console.log("getReports");
    let data = [];
    if(this.collection== null)
      this.collection = await this.afs.firestore.collection("reports").orderBy('order');
    await this.collection.get().then(querySnapshot => {
      querySnapshot.docs.forEach(doc => {
        let object = doc.data();
        object.id = doc.id;
        data.push(object);
      });
    });
    console.log("getReports result",data);
    return data;
  }


  async sendRepport(user_id, type = 'inconnu', data) {
    console.log("sendRepport user_id", user_id);
    console.log("sendRepport type", type);
    console.log("sendRepport data", data);
    const report = {
      type:type,
      data:data,
      created_by: user_id,
      created_at: new Date().toISOString(),
    };
    console.log("data", data);

    await this.afs
      .collection("reports")
      .add(report);
  }
}



// WEBPACK FOOTER //
// ./src/providers/reports/reports.ts